import { transformProData, SEPARATOR, DEFAULT_TIMEZONE } from '../../utils';
import { IChartProRequest, IChartDataProChartGet1Response, IChartProDataVeGet1Request, IChartProSummary } from './models';

export const formChartProParams = ({ instrumentCode, interval = 20, includeVolume = false, timeframe = 110 }: IChartProRequest) => ({
  instrumentCode,
  interval,
  includeVolume,
  timeframe
});

export const getChartProKeyFromRequest = (props: IChartProRequest, timeZone: string = DEFAULT_TIMEZONE) => {
  const { instrumentCode, interval, includeVolume, timeframe } = formChartProParams(props);
  return ['pro', timeZone, instrumentCode, timeframe, interval, includeVolume ? 1 : 0].join(SEPARATOR);
};

export const getChartProKeysFromQueries = (query: IChartProRequest | IChartProRequest[], timeZone: string = DEFAULT_TIMEZONE) =>
  (Array.isArray(query) ? query : [query]).map((q) => getChartProKeyFromRequest(q, timeZone));

export const getQueryFromChartProKey = (key: string): IChartProRequest => {
  const params = key.split(SEPARATOR);
  return {
    // The first param will be chart Type
    instrumentCode: params[2],
    timeframe: Number.parseInt(params[3]) as number,
    interval: Number.parseInt(params[4]) as number,
    includeVolume: params[5] === '1'
  };
};

export const formChartsProApiQuery = (key: string): IChartProDataVeGet1Request => {
  const request = getQueryFromChartProKey(key);
  return {
    TimeFrame: request.timeframe,
    Instrument: request.instrumentCode,
    Interval: request.interval,
    IncludeVolume: request.includeVolume
  };
};

export const transformChartProResponse = (
  instrumentCode: string,
  { ProChartData, UiErrorMessage }: IChartDataProChartGet1Response,
  timeZone: string = DEFAULT_TIMEZONE
): IChartProSummary => {
  return {
    instrumentCode,
    proChartData: transformProData(ProChartData, timeZone),
    uiErrorMessage: UiErrorMessage
  };
};
